import _ from "lodash";
import { FieldValues, UseFormSetValue } from "react-hook-form";

import { IProductionRecurringTime } from "@ryde/shared";

export const normalizeRecurringProductionTimesFieldData = (
  watchedList: unknown,
  fieldName: string,
  setValue: UseFormSetValue<FieldValues>,
): IProductionRecurringTime[] => {
  if (watchedList && !_.isArray(watchedList)) {
    /* guard for invalid value coming from backend*/
    setValue(fieldName, []);
    return [];
  }

  return (watchedList || []) as IProductionRecurringTime[];
};
